import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { useGetShipmentInvoices } from "api/queries/invoice/useGetShipmentInvoices";
import { invoiceQueryKeys } from "api/queries/invoice/invoiceQueryKeys";
import usePermissions from "hooks/usePermissions";
import ShipperShipmentBilling from "pages/shipper/ShipmentBilling/ShipperShipmentBilling";
import ProviderShipmentBilling from "pages/provider/ShipmentBilling/ShipmentBilling";

const initialInvoiceData = [];
const ShipmentBilling = function () {
  const { id: shipmentId } = useParams();
  const queryClient = useQueryClient();
  const methods = useForm({
    shouldFocusError: true,
  });
  const { permissions } = usePermissions();
  const { user_type } = JSON.parse(permissions);
  const navigate = useNavigate();

  const { isLoading, data: invoices = initialInvoiceData } = useGetShipmentInvoices({
    shipmentId,
    options: { select: (data) => data.results },
  });
  const [currentInvoice, setCurrentInvoice] = useState(invoices?.[0] || {});
  const [totalInvoice, setTotalInvoice] = useState([]);

  useEffect(() => {
    if (permissions && !JSON.parse(permissions).permissions.invoicing.view_invoices) navigate("/access-denied");
  }, [permissions]);

  useEffect(() => {
    if (invoices && invoices.length > 0) {
      setCurrentInvoice(invoices[0]);
      setTotalInvoice(invoices);
    }
  }, [invoices]);

  const getAuditLog = () => {
    if (currentInvoice.invoiceId) {
      queryClient.invalidateQueries({ queryKey: invoiceQueryKeys.invoiceAuditListing(currentInvoice.invoiceId) });
    }
  };

  return (
    <div>
      <FormProvider {...methods}>
        <Row>
          {user_type === "shipper" ? (
            <ShipperShipmentBilling
              isLoading={isLoading}
              currentInvoice={currentInvoice}
              setCurrentInvoice={setCurrentInvoice}
              totalInvoice={totalInvoice}
              invoices={invoices}
              getAuditLog={getAuditLog}
            />
          ) : (
            <ProviderShipmentBilling />
          )}
        </Row>
      </FormProvider>
    </div>
  );
};

export default ShipmentBilling;
